import {useEffect, useRef} from "react"

const useMountedRef = () => {
	const mounted = useRef(false)

	// @ts-ignore
	useEffect(() => {
		mounted.current = true
		// eslint-disable-next-line no-return-assign
		return () => (mounted.current = false)
	})

	return mounted
}

export default useMountedRef
